module.exports = __webpack_public_path__ + "media/img/baercode-ui2-d2fa0b642cebefb6be20c7f231df7ee9.png";